<template>
    <div class="app-wrapper">
        <navbar />
        <app-main />
    </div>
</template>

<script>
import { Navbar, AppMain } from './components'

export default {
    name: 'Layout',
    components: {
        Navbar,
        AppMain
    },
    computed: {},
    methods: {}
}
</script>

<style lang="scss" scoped>
@import 'src/styles/mixin.scss';
.app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar {
        position: fixed;
        top: 0;
    }
}
.drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
}
</style>
